import { COLUMN_NAME } from "../../constants/column-types";
import { TableColumn } from "../table/TableColumn";

export const DeviceImproxColumns : TableColumn[] = [
    {
        heading: "Device Name",
        accessor: "name",
        isNumeric: false,
        id: 0,
        active: true,
        sortByName: "devName",
        sortDirection: "asc",
        translationKey: "deviceName",
        isDefault: true,
        columnId: COLUMN_NAME,
    },
    {
        heading: "Site",
        accessor: "site",
        isNumeric: false,
        id: 1,
        active: true,
        sortByName: "site.siteName",
        sortDirection: "asc",
        translationKey: "site",
        isDefault: true,
    },
    {
        heading: "Type",
        accessor: "unitType",
        isNumeric: false,
        id: 2,
        active: true,
        sortByName: "unitType.utName",
        sortDirection: "asc",
        translationKey: "type",
        isDefault: true,
    },
]